// rtk详情
export default {
    operatorInformation: '运营商信息',
    residualFlow: '剩余流量',
    validUntil: '有效期至',
    renew: '续费',
    SCP: '扫码支付',
    connected: '已联网',
    notConnected: '未联网',
    bindingType: '绑定类型',
    private: '私有',
    public: '公开',
}